import type { LevelCfg } from "../types";

export const LEVELS: LevelCfg[] = [
  { rows: 2, cols: 3, timeLimitSec: null },
  { rows: 3, cols: 4, timeLimitSec: 90 },
  { rows: 3, cols: 4, timeLimitSec: 80 },
  { rows: 4, cols: 4, timeLimitSec: 60 },
  { rows: 4, cols: 4, timeLimitSec: 45 },
  { rows: 4, cols: 4, timeLimitSec: 30 },
  { rows: 4, cols: 4, timeLimitSec: 30 },
  { rows: 4, cols: 4, timeLimitSec: 20 },
  //{ rows: 4, cols: 4, timeLimitSec: 60 },
  //{ rows: 4, cols: 4, timeLimitSec: 45 },
];

export const clamp = (n: number, min: number, max: number) =>
  Math.max(min, Math.min(max, n));
